import OccupationalHealth from "./occupationalHealth";
import SitelHelpDesk,{SitelHelpDeskLanguage} from "./sitelHelpDesk";
const phones = {
    OccupationalHealth,
    SitelHelpDesk,
    SitelHelpDeskLanguage
};
export default phones;